import { render } from "./CourseGlyph.vue?vue&type=template&id=1d8059e0&scoped=true"
import script from "./CourseGlyph.vue?vue&type=script&lang=js"
export * from "./CourseGlyph.vue?vue&type=script&lang=js"

import "./CourseGlyph.vue?vue&type=style&index=0&id=1d8059e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8059e0"]])

export default __exports__